import { LegacyDevice } from 'console/device/device';
import { DeviceIconState } from 'console/device/icon/types';
import { GuardState, hasGuard } from 'console/device/device_ts';
import { rideOrParking } from 'console/device/icon/ride-or-parking';
import { Capability } from 'console/device/device-capability';
import { get_z3k_object_state, GuardZone } from 'z3k-config';
import { getDeviceHeatingCircuitsInfo, getGuardZoneAlarm, getSensorAlarm, } from 'console/device/icon/device-state/utils';
/**
 * @function
 * 1. Если А+ биллинг сработал, то не на обслуживании
 * 2. Если не на связи, то офлайн
 * 3. Если авария в контуре, то красный треугольник
 * 4. Если сработал датчик в зоне под охраной, то жёлтые волны с лампочкой
 * 5. Если сработал датчик, то жёлтые волны с точкой
 * 6. Если нет охраны у устройства, то ОНЛАЙН зелёный кружочек
 * 7. Если охрана стоит, то замочек
 * 8. Если ставится на охрану, то замочек с часиками
 * 9. Если движется, то зелёный кружок с белым треугольником
 * 10. Снят с охраны
 * @param dev кусочек от устройства
 * @return едем или стоим
 */
export function getDeviceIconState(dev) {
    if (dev.asp_billing && !dev.asp_billing.in_service) {
        return DeviceIconState.no_service;
    }
    const is_alarm = getDeviceHeatingCircuitsInfo(dev);
    const is_guard_zone_alarm = getGuardZoneAlarm(dev);
    if (!dev.online) {
        return DeviceIconState.offline;
    }
    if (is_alarm) {
        return DeviceIconState.alarm;
    }
    if (is_guard_zone_alarm) {
        return DeviceIconState.guard_zone_alarm;
    }
    const is_some_sensor_alarm = getSensorAlarm(dev);
    if (is_some_sensor_alarm) {
        return DeviceIconState.sensor_alarm;
    }
    if (!hasGuard(dev)) {
        return DeviceIconState.online;
    }
    const guard_state = dev.guard_state ?? (dev.io != null ? dev.io['guard-state'] : '');
    if (guard_state === GuardState.enabled) {
        return DeviceIconState.guard_on;
    }
    if (dev.last_gps != null && dev.last_gps.length > 0) {
        const ride_or_parking = rideOrParking(dev.last_gps[0], dev.last_gps[1]);
        if (ride_or_parking === '-ride') {
            return DeviceIconState.online_ride;
        }
    }
    if (guard_state === GuardState.enabling) {
        return DeviceIconState.guard_enabling;
    }
    if (LegacyDevice.has_capability(dev?.capabilities, Capability.has_z3k_settings)) {
        const guard_zones = dev.z3k_config?.guard_zones ?? [];
        if (!(guard_zones.length > 0)) {
            return DeviceIconState.online;
        }
        if (guard_zones.every((zone) => {
            const state = get_z3k_object_state(dev.z3k_state, zone.id);
            return state && GuardZone.isOnGuard(state);
        })) {
            return DeviceIconState.guard_on;
        }
        return DeviceIconState.guard_off_silent;
    }
    return DeviceIconState.guard_off;
}
